window.$ = window.jQuery = require('jquery');
// import 'bootstrap';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';
window.select2 = require('select2');
import './custom';
import './mds-qty';
import './keen-slider';


document.addEventListener("DOMContentLoaded", function(){
// make it as accordion for smaller screens
    if (window.innerWidth < 992) {

        // close all inner dropdowns when parent is closed
        document.querySelectorAll('.navbar .dropdown').forEach(function(everydropdown){
            everydropdown.addEventListener('hidden.bs.dropdown', function () {
                // after dropdown is hidden, then find all submenus
                this.querySelectorAll('.submenu').forEach(function( everysubmenu ){
                    // hide every submenu as well
                    everysubmenu.style.display = 'none';
                });
            })
        });

        document.querySelectorAll('.dropdown-menu a').forEach(function(element){
            element.addEventListener('click', function (e) {
                let nextEl = this.nextElementSibling;
                if(nextEl && nextEl.classList.contains('submenu')) {
                    // prevent opening link if link needs to open dropdown
                    e.preventDefault();
                    if(nextEl.style.display === 'block'){
                        nextEl.style.display = 'none';
                    } else {
                        nextEl.style.display = 'block';
                    }
                }
                if(e.target === e.currentTarget) {
                    e.stopPropagation()
                } else {
                    //Do nothing
                }
            });
        })
    }
// end if innerWidth

    window.addEventListener('scroll', function() {
        let navbar_top = document.getElementById('navbar_top');
        if (navbar_top) {
            if (window.scrollY > 50) {
                navbar_top.classList.add('fixed-top');
                document.getElementById('header-top').classList.add('d-none');
                // add padding top to show content behind navbar
                let navbar_height = document.querySelector('.navbar').offsetHeight;
                document.body.style.paddingTop = navbar_height + 'px';
            } else {
                navbar_top.classList.remove('fixed-top');
                document.getElementById('header-top').classList.remove('d-none');
                // remove padding top from body
                document.body.style.paddingTop = '0';
            }
        }
    });

    document.querySelectorAll('.search-item').forEach(function(element){
        element.addEventListener('click', function (e) {

            if (e.target.classList.contains('add_to_cart_button')) return;

            if(e.target === e.currentTarget) {

            } else {
                window.location.href = element.getAttribute('data-url');
                //Do nothing
            }
        });
    })
});
